"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IntentionDto = void 0;
const swagger_1 = require("@nestjs/swagger");
class IntentionDto {}
exports.IntentionDto = IntentionDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], IntentionDto.prototype, "publicId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Display label shown to users'
}), __metadata("design:type", String)], IntentionDto.prototype, "name", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Action description prompt shown to users or used by the app'
}), __metadata("design:type", String)], IntentionDto.prototype, "prompt", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true,
  description: 'Additional description shown in the admin UI'
}), __metadata("design:type", Object)], IntentionDto.prototype, "description", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], IntentionDto.prototype, "emoji", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false
}), __metadata("design:type", Number)], IntentionDto.prototype, "sortOrder", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false
}), __metadata("design:type", Boolean)], IntentionDto.prototype, "isActive", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false
}), __metadata("design:type", String)], IntentionDto.prototype, "createdAt", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false
}), __metadata("design:type", String)], IntentionDto.prototype, "updatedAt", void 0);
//# sourceMappingURL=Intention.dto.js.map